// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Next = require("../../next/Next.bs.js");
var React = require("react");
var UserSession = require("../UserSession/UserSession.bs.js");

var allowedRoutes = [
  "/client",
  "/client/account"
];

function use() {
  var router = Next.useRouter();
  var pathname = Next.Router.pathname(router);
  var clientInfo = UserSession.useClientInfoOpt();
  React.useEffect((function () {
          if (clientInfo !== undefined) {
            var exit = 0;
            var tmp = clientInfo.status;
            if (tmp === "ACTIVE" || tmp === "ACCESS_REVOKED" || tmp === "AGENT_NOT_AUTHORIZED") {
              switch (tmp) {
                case "ACTIVE" :
                    break;
                case "ACCESS_REVOKED" :
                case "AGENT_NOT_AUTHORIZED" :
                    exit = 1;
                    break;
                
              }
            }
            if (exit === 1) {
              if (!allowedRoutes.some(function (p) {
                      return p === pathname;
                    })) {
                Next.Router.replace("/client", undefined, undefined, router);
              }
              
            }
            
          }
          
        }), [
        clientInfo,
        pathname
      ]);
}

exports.allowedRoutes = allowedRoutes;
exports.use = use;
/* Next Not a pure module */
